<template>
  <zen-one :showuserinfo="false" title="" :crumbs="crumbs">
	  <z-page title="Semakan/Tindakan Perkhidmatan Pembiakan">
      <div class="table_scrol">
         <div class="w-card__content content-hardcode mb3">
          <w-form v-model="valid" @validate="cari" ref="frm">
            <w-flex class="mt3">
              <z-select style="margin:5px; " v-model="pencarian.lkp_art_id" :items="lkp_art" label="Jenis Perkhidmatan" />
              <z-select style="margin:5px; " v-model="pencarian.premis_id" :items="premis_id" label="ID Premis" />
              <z-select style="margin:5px; " v-model="pencarian.lkp_status_id" :items="lkp_status" label="Status" />
            </w-flex>
          </w-form>
          <w-flex justify-end class="mt2">
              <w-button class="mr2" v-on:click="resetPencarian()" bg-color="warning">
                  <w-icon>fal fa-redo</w-icon>&nbsp;SET SEMULA</w-button>
              <w-button class="mr2" bg-color="primary" @click="$refs.frm.validate()">
                  <w-icon>fal fa-search</w-icon>&nbsp;CARI
              </w-button>
          </w-flex>
        </div>
  		  <z-table title="Senarai Semakan/Tindakan Perkhidmatan Pembiakan" :headers="table.headers" :items="table.items" :meta="table.meta" :mobile-breakpoint="700">
  		    <template #header-label="{ header, label, index }">
  		      <template v-if="header.key == 'action'">
  			      <!-- <w-icon xs>fal fa-pencil</w-icon> -->
              Tindakan
            </template>
  		      <template v-else>
  		      	{{ label }}
  		      </template>
  		    </template>
  		    <template #item-cell.action="{ item, label, header, index }">
  		      <w-flex class="flex justify-center">
              <w-tooltip md top align-left color="white" bg-color="black" >
                <template #activator="{ on }">
                  <w-button  bg-color="info" v-on="on"  v-if=" $zutil.anyRole(['1', '2', '5']) && (item.lkp_status_id ==18||item.lkp_status_id ==21)" :route="$route('art.permohonan.form',0)+'?salin='+item.id" class="be fs-2"><div style="width: 8px"></div>
                    <w-icon md class="mr2">fal fa-copy</w-icon>
                  </w-button>
                </template>
                Salin
              </w-tooltip>
                &nbsp;
              <w-tooltip top color="white" bg-color="black">
                 <template #activator="{ on }">
                    <w-button  bg-color="warning" v-on="on" v-if="item.lkp_status_id ==19 && $zutil.anyRole(['1', '2', '5'])" :route="$route('art.permohonan.form',item.id)" class="be fs-2"><div style="width: 8px"></div>
                    <w-icon md class="mr2">fal fa-pencil</w-icon>
                    </w-button>
                  </template>
                  Kemaskini
                </w-tooltip>
                &nbsp;
              <w-tooltip md top align-right color="white" bg-color="black">
                 <template #activator="{ on }">
                    <inertia-link :href="$route('art.semakan.show',item.id)" v-on="on" class="w-button w-button--dark size--md info-dark1--bg"> <div style="width: 8px"></div>
                      <w-icon md class="mr2">fal fa-eye</w-icon>
                    </inertia-link>
                  </template>
                  Papar
                </w-tooltip>
  		      </w-flex>
  		    </template>
  		  </z-table>
      </div>
	  </z-page>
  </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'

export default {
  extends: ZResource,
  props: {
    items: [Array, Object],
  },
  data() {
    return {
      resourceurl: 'art.semakan',
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Senarai Perkhidmatan', route: '/art/semakan' },
        { label: 'ART Semakan/Tindakan', route: '/art/semakan' },
      ],
      title : 'Art Permohonan',
      form : this.d_form,
      

      pencarian: {
         premis_id: '',
         lkp_art_id: '',
         lkp_status_id: '',
      },
      premis: [],
      premis_id: [],
      lkp_art: [],
      lkp_status :[],
      
      
    }
  },
  methods: {

   cari() {
       if(!this.valid) return;

       let params = {
       ...this.pencarian,
       };
       params.page = 1;
       this.$inertia.visit(route(route().current(), params), {
           preserveState: true,
           preserveScroll: true,
       });
    },

    resetPencarian() {
       this.$inertia.visit(route(route().current()));
    },

    getStatus(){
      this.$zcomm.get(this.api_service + 'lookup/status_art', {}).then(res => {
        this.lkp_status = res
      })
    },

    getPremis(){
     this.$zcomm.get(this.api_service + 'lookup/premis', {}).then(res => {
       this.premis = res
     })
   },

   getPremisCarian(){
         this.$zcomm.get(this.api_service + 'lookup/premis', {}).then(res => {
           this.premis_id = res
         })
       },

    getArt(){
      this.$zcomm.get(this.api_service + 'lookup/art', {}).then(res => {
        this.lkp_art = res
      })
    },
    
  
  },

  watch: {

  },
  mounted() {
   this.getStatus();
   this.getPremis();
   this.getPremisCarian();
   this.getArt();
    // override default setting
    this.dialog.width = 500
      
  },
}
</script>
